/* =========================================================
   ALORI — Blog Article interactions (vanilla, no deps)
   ========================================================= */
(function () {
  "use strict";

  var article = document.querySelector("[data-article-body]");
  var bar     = document.querySelector(".progress__bar");
  var toTop   = document.querySelector(".totop");
  var rail    = document.querySelector(".product-rail");
  var tocLinks = [];
  var railDismissed = false;

  /* ---- Rail anchor: capture position before any scroll ---- */
  var railAnchor = null;
  function captureRailAnchor() {
    if (!rail) return;
    var prev = rail.style.cssText;
    rail.style.cssText += ';position:static!important;top:auto!important;right:auto!important;width:auto!important;left:auto!important';
    var rect = rail.getBoundingClientRect();
    rail.style.cssText = prev;
    if (rect.width < 10) return;
    railAnchor = { fromRight: window.innerWidth - rect.right, width: rect.width };
  }

  if (document.readyState === "complete") {
    captureRailAnchor();
  } else {
    window.addEventListener("load", captureRailAnchor);
  }

  /* ---- Buybox: fixed + fade-in, stops at article shell bottom ---- */
  var TOP_PX = 100;
  function updateBuybox() {
    if (!rail || railDismissed) return;
    var scrollY = window.scrollY || window.pageYOffset;
    var hero = document.querySelector(".art-hero, .cover-hero");
    var threshold = hero ? (hero.offsetTop + hero.offsetHeight + 60) : 400;

    /* Stop the rail before it overlaps the related/newsletter sections */
    var shell = document.querySelector(".article-shell");
    if (shell) {
      var shellRect = shell.getBoundingClientRect();
      var shellBottomFromTop = shellRect.bottom; /* px from viewport top */
      var railHeight = rail.offsetHeight || 400;
      /* If shell bottom is above (TOP_PX + railHeight), rail would overflow — hide it */
      if (shellBottomFromTop < TOP_PX + railHeight + 40) {
        rail.classList.remove("is-visible");
        rail.style.position = "";
        rail.style.top = "";
        rail.style.right = "";
        rail.style.width = "";
        rail.style.left = "";
        return;
      }
    }

    if (scrollY > threshold) {
      if (!railAnchor) captureRailAnchor();
      if (!railAnchor) return;
      rail.style.position = "fixed";
      rail.style.top      = TOP_PX + "px";
      rail.style.right    = railAnchor.fromRight + "px";
      rail.style.width    = railAnchor.width + "px";
      rail.style.left     = "auto";
      rail.classList.add("is-visible");
    } else {
      rail.style.position = "";
      rail.style.top      = "";
      rail.style.right    = "";
      rail.style.width    = "";
      rail.style.left     = "";
      rail.classList.remove("is-visible");
    }
  }

  /* ---- Close button handler ---- */
  document.addEventListener("DOMContentLoaded", function () {
    var closeBtn = document.querySelector("[data-bb-close]");
    if (closeBtn && rail) {
      closeBtn.addEventListener("click", function () {
        railDismissed = true;
        rail.classList.remove("is-visible");
        setTimeout(function () { rail.style.display = "none"; }, 350);
      });
    }
  });

  /* ---- Auto-build TOC from h2 elements ---- */
  function buildTOCFromHeadings() {
    if (!article) return;
    var h2s = Array.prototype.slice.call(article.querySelectorAll("h2"));
    if (!h2s.length) return;
    var railList   = document.getElementById("acn-toc-list");
    var inlineList = document.getElementById("acn-toc-inline");
    h2s.forEach(function (h2, i) {
      if (!h2.id) {
        var slug = (h2.textContent || "").trim().toLowerCase()
          .replace(/[^a-z0-9\s-]/g, "").replace(/\s+/g, "-").replace(/^-|-$/g, "");
        h2.id = "sec-" + (i + 1) + (slug ? "-" + slug.slice(0, 40) : "");
      }
      var text = (h2.textContent || "").trim();
      [railList, inlineList].forEach(function (list) {
        if (!list) return;
        var li = document.createElement("li");
        var a  = document.createElement("a");
        a.href = "#" + h2.id;
        a.textContent = text;
        li.appendChild(a);
        list.appendChild(li);
      });
    });
    tocLinks = Array.prototype.slice.call(document.querySelectorAll(".toc__list a"));
    buildSpy();
  }

  /* ---- Progress + back-to-top ---- */
  function onScroll() {
    var y = window.scrollY || window.pageYOffset;
    if (bar && article) {
      var start = article.offsetTop;
      var total = article.offsetHeight - window.innerHeight * 0.5;
      var pct   = Math.max(0, Math.min(1, (y - start + window.innerHeight * 0.5) / total));
      bar.style.width = (pct * 100).toFixed(2) + "%";
    }
    if (toTop) toTop.classList.toggle("is-visible", y > 700);
    updateBuybox();
  }

  /* ---- TOC scroll-spy ---- */
  var sections = [];
  function buildSpy() {
    sections = tocLinks.map(function (a) {
      var id = a.getAttribute("href").slice(1);
      var el = document.getElementById(id);
      return el ? { link: a, el: el } : null;
    }).filter(Boolean);
  }
  function spy() {
    if (!sections.length) return;
    var y = (window.scrollY || window.pageYOffset) + 120;
    var current = sections[0];
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].el.offsetTop <= y) current = sections[i];
    }
    tocLinks.forEach(function (a) { a.classList.remove("is-active"); });
    if (current) current.link.classList.add("is-active");
  }

  /* ---- Smooth-scroll anchors ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener("click", function (e) {
      var id = a.getAttribute("href").slice(1);
      if (!id) return;
      var el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      var top = el.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - 88;
      window.scrollTo({ top: top, behavior: "smooth" });
      var inline = a.closest(".toc-inline");
      if (inline) { var d = inline.querySelector("details"); if (d) d.open = false; }
    });
  });

  /* ---- Back to top ---- */
  if (toTop) {
    toTop.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  /* ---- Share buttons ---- */
  function flash(btn, label) {
    var prev = btn.getAttribute("aria-label");
    btn.setAttribute("aria-label", label);
    btn.classList.add("is-done");
    setTimeout(function () { btn.setAttribute("aria-label", prev); btn.classList.remove("is-done"); }, 1600);
  }
  document.querySelectorAll("[data-share]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var kind  = btn.getAttribute("data-share");
      var url   = window.location.href;
      var title = document.title;
      if (kind === "copy") { if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { flash(btn, "Link copied"); }); return; }
      if (kind === "native" && navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
      var map = {
        x:         "https://twitter.com/intent/tweet?url=" + encodeURIComponent(url) + "&text=" + encodeURIComponent(title),
        facebook:  "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url),
        pinterest: "https://pinterest.com/pin/create/button/?url=" + encodeURIComponent(url) + "&description=" + encodeURIComponent(title)
      };
      if (map[kind]) window.open(map[kind], "_blank", "noopener,width=600,height=520");
    });
  });

  /* ---- Auto read-time (225 wpm) ---- */
  var rt = document.querySelector("[data-readtime]");
  if (rt && article) {
    rt.textContent = Math.max(1, Math.round((article.innerText || "").trim().split(/\s+/).length / 225)) + " min read";
  }

  /* ---- On resize: recapture anchor ---- */
  window.addEventListener("resize", function () {
    if (rail && !railDismissed) {
      rail.style.cssText = "";
    }
    railAnchor = null;
    captureRailAnchor();
    buildSpy();
    onScroll();
    spy();
  });

  /* ---- Init ---- */
  buildTOCFromHeadings();
  var ticking = false;
  function tick() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { onScroll(); spy(); ticking = false; });
  }
  window.addEventListener("scroll", tick, { passive: true });
  onScroll();
  spy();

})();
